
const hindiLang = {
  home: 'होम',
  aboutUs: 'हमारे बारे में',
  ourTemplates: 'हमारे टेम्पलेट्स',
  createaStunningwebsite: 'अपने व्यक्तिगत, पेशेवर या व्यावसायिक आवश्यकताओं के लिए 5,000+ से अधिक वेबसाइट टेम्पलेट्स के साथ एक शानदार वेबसाइट बनाएं।',
  ourMission: 'हमारा मिशन',
  helpCenter: 'सहायता केंद्र',
  unread: 'अपठित',
  markRead: 'पढ़ा हुआ चिह्नित करें',
  noNotifications: 'कोई सूचनाएँ नहीं',
  accountSetting: 'खाता सेटिंग',
  myOrder: 'मेरा ऑर्डर',
  enquires: 'जांचें',
  wishlist: "इच्छा-सूची",
  manageYourTemplate: 'अपने टेम्पलेट प्रबंधित करें',
  signOut: 'साइन आउट',
  logIn: 'लॉग इन',
  getStarted: 'शुरू करें',
  clear: "हटाएं",

  //Home
  getProfessionalWebsiteFor: "एक कप चाय की कीमत पर एक पेशेवर वेबसाइट प्राप्त करें!",
  justAt: "सिर्फ",
  perDay: "प्रति दिन",
  playVideo: "वीडियो चलाएं",
  madeInIndia: "भारत में निर्मित",
  forThePeopleOfIndia: "भारत के लोगों के लिए",
  wideSelectionOfTemplates: "आपकी आवश्यकताओं के अनुसार टेम्पलेट्स का विस्तृत चयन",
  withOverProfessionBusiness: "4950+ पेशे/व्यवसाय टेम्पलेट्स के साथ, अपने क्षेत्र के अनुरूप सही वेबसाइट बनाएं",
  howToCreateStunningWebsiteWithUs: "हमारे साथ शानदार वेबसाइट कैसे बनाएं",
  beItCvorProfessionalLookingWebsite: "चाहे वह सीवी हो या पेशेवर दिखने वाली वेबसाइट, अब आप हमारी टेम्पलेट्स का उपयोग करके अपनी जरूरतों के अनुसार अनुकूलित शानदार वेबसाइट बना सकते हैं। अधिक जानकारी के लिए हमारा वीडियो देखें।",
  watchVideo: "वीडियो देखें",
  why: "क्यों",
  india: "भारत",
  appIsTheBest: "ऐप आपके लिए सबसे अच्छा विकल्प है",
  digital: "डिजिटल",
  my: "मेरा",
  creatingProfessionalAndVisually: "एक पेशेवर और दृश्य रूप से आकर्षक वेबसाइट बनाना अब पहले से कहीं आसान है। MyDigitalIndia ऐप पर, हम आपको अपनी वेबसाइट को सबसे अलग बनाने के लिए सर्वश्रेष्ठ उपकरण और सेवाएं प्रदान करने का प्रयास करते हैं।",
  realTimeContentUpdates: "रियल-टाइम कंटेंट अपडेट्स",
  updateYourWebsiteContentAnytime: "अपनी वेबसाइट की सामग्री को कभी भी आसानी से अपडेट करें।",
  instantContactNotifications: "तत्काल संपर्क सूचनाएं",
  receiveImmediateInboxAlertsForEvery: "हर ग्राहक पूछताछ के लिए तत्काल इनबॉक्स अलर्ट प्राप्त करें।",
  aIPoweredMarketing: "एआई संचालित मार्केटिंग",
  enjoyBestAutomatedMarketingThrough: "एआई तकनीक के माध्यम से सर्वोत्तम स्वचालित मार्केटिंग का आनंद लें।",
  easyCancellationPolicy: "आसान रद्दीकरण नीति",
  cancelAnytimeWithSeamlessHassle: "बिना किसी परेशानी के कभी भी रद्द करें।",
  superiorPerformanceAndSpeed: "उत्तम प्रदर्शन और गति",
  experienceFastLoadingTimesForAn: "तेज लोडिंग समय के साथ एक आकर्षक उपयोगकर्ता अनुभव प्राप्त करें।",
  seoOptimizedDesign: "एसईओ-अनुकूलित डिज़ाइन",
  improveYourSearchEngineRankings: "निर्मित एसईओ सुविधाओं के साथ अपने खोज इंजन रैंकिंग में सुधार करें।",
  enterpriseGradeSecurity: "एंटरप्राइज-ग्रेड सुरक्षा",
  protectYourSiteWithAdvanced: "उन्नत, एंटरप्राइज-स्तरीय सुरक्षा के साथ अपनी साइट की सुरक्षा करें।",
  reliableMultiCloudHosting: "विश्वसनीय मल्टी-क्लाउड होस्टिंग",
  ensureUptimeEvenDuringTrafficSpikes: "मल्टी-क्लाउड होस्टिंग के साथ ट्रैफिक बढ़ने पर भी 99.9% अपटाइम सुनिश्चित करें।",
  weGotYouCoveredWithEssentialsYouNeed: "डिजिटल सफलता के लिए आवश्यक सभी चीजों के साथ हम आपके साथ हैं।",
  weMakeSureThatYouGetAllTheMustHaveFeatures: "हम यह सुनिश्चित करते हैं कि आप अपनी ऑनलाइन यात्रा को नए स्तर पर शुरू और बढ़ाने के लिए सभी आवश्यक सुविधाएं प्राप्त करें।",
  templates: "टेम्पलेट्स",
  ourMission: "मिशन",
  OurMission: 'हमारा मिशन',
  showcase: 'प्रदर्शनी',
  atMyDigitalIndiaOurMissionIsToDigitizeIndia: "MyDigitalIndia में, हमारा मिशन प्रधानमंत्री के डिजिटल इंडिया पहल के साथ भारत को डिजिटाइज़ करना है। हम हर पेशेवर और व्यवसाय मालिक को एक सस्ती और शक्तिशाली ऑनलाइन उपस्थिति प्रदान करने के लिए प्रयासरत हैं, जिससे वे व्यापक दर्शकों तक पहुँच सकें। उच्च गुणवत्ता वाली वेबसाइट टेम्पलेट्स को सबसे सस्ती दरों पर पेश करके, हम डिजिटल पहुंच को सभी के लिए एक वास्तविकता बनाने का लक्ष्य रखते हैं।",
  shriNarendraModi: "श्री नरेंद्र मोदी",
  honblepmOfIndia: "माननीय भारत के प्रधानमंत्री",
  khushbuBhati: "खुशबू भाटी",
  founder: "संस्थापक",
  testimonials: "प्रशंसापत्र",
  discoverHowMyDigitalIndiaApp: "पता लगाएं कि MyDigitalIndia ऐप ने आपकी तरह के व्यवसायों की ऑनलाइन उपस्थिति को कैसे बदल दिया है। हमारे ग्राहकों की सफलता की कहानियां हमारी उपयोग में आसानी, असाधारण सुविधाओं और शीर्ष स्तरीय समर्थन को उजागर करती हैं, जिसने हमें भारत के पेशेवरों और व्यवसायों के लिए एक विश्वसनीय विकल्प बना दिया है।",
  akritiDubey: "आकृति दुबे",
  charteredAccountant: "चार्टर्ड अकाउंटेंट",
  connectWithUsNowAndStartYourJourney: "अभी हमसे जुड़ें और डिजिटल सफलता की अपनी यात्रा शुरू करें।",
  haveAQuestion: "क्या आपके पास कोई प्रश्न है?",

  //footer
  atMyDigitalIndiaWeAreDedicated: "MyDigitalIndia में, हम पेशेवरों और व्यवसायों को उनके ऑनलाइन उपस्थिति को मजबूत बनाने के लिए आवश्यक उपकरण प्रदान करने के लिए समर्पित हैं। भारत में सस्ते और बहुमुखी वेबसाइट टेम्पलेट्स की पेशकश करने वाले अग्रणी के रूप में, हमें अपने उपयोगकर्ता-अनुकूल प्लेटफ़ॉर्म और उत्कृष्ट ग्राहक सेवा पर गर्व है।",
  pages: "पेजेस",
  blogs: "ब्लॉग्स",
  termsAndConditions: "नियम और शर्तें",
  privacyPolicy: "गोपनीयता नीति",
  help: "सहायता",
  contactUs: "हमसे संपर्क करें",
  access: "पहुंच",
  signIn: "साइन इन",

  //About us
  atMyDigitalIndiaWeAreCommittedToProviding: "MyDigitalIndia में, हम सभी को एक अद्वितीय और पेशेवर ऑनलाइन उपस्थिति प्रदान करने के लिए प्रतिबद्ध हैं, चाहे उनकी तकनीकी क्षमता या पृष्ठभूमि कैसी भी हो। चाहे आप एक व्यवसाय, उद्यमी, पेशेवर, या व्यक्तिगत वेबसाइट बनाने की तलाश में हों, हमारा लक्ष्य आपको सुंदर और उपयोगी वेबसाइट आसानी से डिजाइन करने में सक्षम बनाना है। हमारी उपयोगकर्ता-अनुकूल सेवाएं सभी के लिए एक सहज अनुभव सुनिश्चित करती हैं, चाहे आपकी उम्र या उद्देश्य कुछ भी हो।",
  whoWeAre: "हम कौन हैं",
  foundedByDedicatedTeamOfTechEnthusiasts: "MyDigitalIndia को तकनीकी उत्साही और डिज़ाइन विशेषज्ञों की एक समर्पित टीम द्वारा स्थापित किया गया है, जो भारत के डिजिटल परिदृश्य में क्रांति लाने के मिशन पर हैं। हमारे संस्थापकों ने देखा कि व्यक्तियों, छोटे व्यवसायों और उद्यमियों को एक पेशेवर ऑनलाइन उपस्थिति स्थापित करने में कितनी कठिनाइयों का सामना करना पड़ता है, बिना उच्च लागत या तकनीकी ज्ञान के। MyDigitalIndia को इस अंतर को भरने और व्यक्तिगत, पेशेवर या व्यावसायिक उपयोग के लिए अनुकूलित व्यापक वेब समाधान प्रदान करने के लिए बनाया गया था।",
  meetOurFounder: "हमारे संस्थापक से मिलें",
  mrsKhushbuBhatiTheVisionary: "श्रीमती खुशबू भाटी, MyDigitalIndia की संस्थापक, डिजिटल सशक्तिकरण और पहुंच की प्रबल समर्थक हैं। प्रौद्योगिकी और डिज़ाइन में मजबूत पृष्ठभूमि के साथ, श्रीमती भाटी हमेशा उच्च गुणवत्ता वाले वेब समाधानों को सभी के लिए सुलभ बनाने की इच्छा से प्रेरित रही हैं।",
  ourVision: "हमारा दृष्टिकोण",
  ourVisionIsDigitallyEmpowered: "हमारा दृष्टिकोण एक डिजिटल रूप से सशक्त भारत का है, जहाँ प्रत्येक व्यक्ति से लेकर व्यवसाय, बड़ा हो या छोटा, ऑनलाइन फल-फूल सके। हमारे किफायती और व्यापक वेब समाधानों के साथ, हम डिजिटल अंतर को पाटने और देशभर में विकास को प्रोत्साहित करने का लक्ष्य रखते हैं। हम डिजिटल युग में सफलता के लिए आवश्यक उपकरण और संसाधन प्रदान करने के लिए प्रतिबद्ध हैं, और सभी के लिए एक गतिशील और समावेशी डिजिटल अर्थव्यवस्था में योगदान करते हैं।",
  joinUs: "हमसे जुड़ें",
  becomePartofTheMyDigitalIndiaCommunity: "MyDigitalIndia समुदाय का हिस्सा बनें और एक मजबूत ऑनलाइन उपस्थिति बनाने की दिशा में पहला कदम उठाएं। चाहे आप एक व्यक्ति, छोटे व्यवसाय के मालिक, या स्वतंत्र पेशेवर हों, हम आपकी यात्रा का समर्थन करने के लिए यहां हैं। आइए एक ऐसा डिजिटल भविष्य बनाएं जो समावेशी, नवोन्मेषी और डिजिटल इंडिया की दृष्टि के अनुरूप हो!",
  signUp: "साइन अप",

  //myAccount
  myAccount: "मेरा खाता",
  hereYouCanManageAllYourAccount: "यहां आप अपने सभी खाता विवरण, सदस्यता और नवीनीकरण प्रबंधित कर सकते हैं।",
  accountDetails: "खाता विवरण",
  fullName: "पूरा नाम",
  email: "ईमेल",
  contact: "संपर्क",
  haveYouForgetYourPassword: "क्या आप अपना पासवर्ड भूल गए हैं?",
  resetPassword: "पासवर्ड रीसेट करें",
  savedPayments: "सहेजे गए भुगतान",
  debitCardCreditCard: "डेबिट कार्ड/क्रेडिट कार्ड",
  subscription: "सदस्यता",
  youHaveBeenSubscribed: "आप हमारी वार्षिक योजना की सदस्यता ले चुके हैं।",
  startDate: "आरंभ तिथि",
  endDate: "समाप्ति तिथि",
  yourSubscriptionEndingSoon: "आपकी सदस्यता जल्द समाप्त हो रही है?",
  renewNow: "अभी नवीनीकरण करें",
  doYouWishToCancelYourSubscription: "क्या आप अपनी सदस्यता रद्द करना चाहते हैं?",
  WhenYourRemainingDaysLessThan: "जब आपके पास 60 से कम दिन बचें हों, तब आप रिन्यू कर सकते हैं।",
  cancelSubscription: "सदस्यता रद्द करें",
  deleteAccount: "खाता हटाएं",
  areYouSureYouWantToDelete: "क्या आप वाकई अपना खाता हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
  cancel: "रद्द करें",
  confirm: "पुष्टि करें",
  otherSettings: "अन्य सेटिंग्स",
  doYouWishToDeleteYourAccount: "क्या आप अपना खाता हटाना चाहते हैं?",
  areYouSureYouWantToCancelYourSubscription: "क्या आप सुनिश्चित हैं कि आप अपनी सदस्यता रद्द करना चाहते हैं?",
  renewSubscription: "सदस्यता नवीनीकरण करें",
  readyToRenewYourSubscriptionEnsureContinuousService: "क्या आप अपनी सदस्यता नवीनीकरण के लिए तैयार हैं? सुनिश्चित करें कि आपकी सेवा बिना रुके जारी रहे! आज ही नवीनीकरण करें और अपने वेबसाइट को सुचारू रूप से चलाते रहें। MyDigitalIndia की सभी सुविधाओं और लाभों का आनंद लें।",
  billingDetails: "बिलिंग विवरण",
  yourName: "आपका नाम",
  gstin: "जीएसटीआईएन",
  optional: "वैकल्पिक",
  day: "दिन",
  getCuttingEdgeAIDrivenMarketingDesigned: "अपनी डिजिटल मार्केटिंग रणनीति को अनुकूलित और बेहतर बनाने के लिए अत्याधुनिक एआई-ड्रिवन मार्केटिंग प्राप्त करें।",
  selectedYourDomain: "आपका डोमेन चुना गया है",
  youHaveSelectedPremiumDomain: "आपने एक प्रीमियम डोमेन चुना है। आपसे शुल्क लिया जाएगा Rs",
  basePrice: "मूल मूल्य",
  yearly: "वार्षिक",
  days: "दिन",
  premiumDomain: "प्रीमियम डोमेन",
  addOn: "ऐड ऑन",
  aiMarketing: "एआई मार्केटिंग",
  total: "कुल",
  checkout: "चेकआउट",
  rs: "₹",

  //myOrders
  myOrders: "मेरे ऑर्डर",
  hereYouCanManageAllYourOrders: "यहां आप अपने सभी ऑर्डर प्रबंधित कर सकते हैं।",
  orderNo: "ऑर्डर नंबर",
  dateOfPublish: "प्रकाशन की तिथि",
  domainName: "डोमेन नाम",
  dateOfRenewal: "नवीनीकरण की तिथि",
  view: "देखें",
  printReceipt: "रसीद प्रिंट करें",
  downloadReceipt: "रसीद डाउनलोड करें",

  //enquires
  enquires: "पूछताछ",
  manageAllYourInquiresReceived: "संपर्क फ़ॉर्म के माध्यम से प्राप्त सभी पूछताछ को प्रबंधित करें।",
  enquiry: "पूछताछ",
  name: "नाम",
  mobileNo: "मोबाइल नंबर",
  message: "संदेश",

  //manageYourTemplates
  manageYourTemplates: "अपने टेम्पलेट्स प्रबंधित करें",
  hereYouCanManageUptoTemplates: "यहां आप आसानी से 5 टेम्पलेट्स तक प्रबंधित कर सकते हैं। चाहे आप अपडेट करना चाहते हों, कस्टमाइज़ करना चाहते हों या टेम्पलेट्स बदलना चाहते हों, यह पेज सभी आवश्यक विकल्प प्रदान करता है।",
  desktop: "डेस्कटॉप",
  mobile: "मोबाइल",
  doYouWishSwitchThisTemplate: "क्या आप इस टेम्पलेट को बदलना चाहते हैं?",
  currentThemeWeillBeSwitched: "वर्तमान थीम को नए चयनित थीम में बदला जाएगा। वर्तमान थीम के सभी डेटा को नए थीम में स्थानांतरित किया जाएगा।",
  newTheme: "नया थीम",
  change: "बदलें",
  switch: "बदलें",
  selectNewTheme: "नया थीम चुनें",
  currentTheme: "वर्तमान थीम",
  domain: "डोमेन",
  draft: "ड्राफ्ट",
  underReview: "समीक्षा के अधीन",
  published: "प्रकाशित",
  inactive: "निष्क्रिय",
  editWebsite: "वेबसाइट संपादित करें",
  publish: "प्रकाशित करें",
  preview: "पूर्वावलोकन",
  switchTemplate: "टेम्पलेट बदलें",
  doYouWantToPublishThisTemplate: "क्या आप इस टेम्पलेट को प्रकाशित करना चाहते हैं?",
  theSelectedThemeWillBeApplied: "चयनित थीम लागू किया जाएगा। पिछले थीम से कोई डेटा स्थानांतरित नहीं किया जाएगा। यदि आप डेटा स्थानांतरित करना चाहते हैं, तो क्लिक करें",
  switchTemplate: "टेम्पलेट बदलें",

  edit: "संपादित करें",
  all: "सभी",
  typeYourNiche: "अपनी विशेषता लिखें",

  //Edit website
  createAWebsiteThatsUniquelyYours: "एक वेबसाइट बनाएं जो पूरी तरह से आपकी हो! निम्नलिखित विवरण भरें। हमारे दिखाएँ/छिपाएँ टॉगल स्विच का उपयोग करके आसानी से उन अनुभागों का चयन करें जिन्हें आप चाहते हैं। हर पहलू को व्यक्तिगत बनाएं और केवल कुछ क्लिक के साथ अपने विज़न को साकार करें।",
  back: "वापस",
  personalInformation: "व्यक्तिगत जानकारी",
  companyName: "कंपनी का नाम",
  companyTagline: "कंपनी का टैगलाइन",
  enterYouName: "अपना नाम दर्ज करें",
  enterYouCompanyName: "अपनी कंपनी का नाम दर्ज करें",
  enterYouCompanyTagline: "अपनी कंपनी का टैगलाइन दर्ज करें",
  profession: "व्यवसाय",
  enterSelfDescribes: "स्वयं का विवरण दर्ज करें",
  phone: "फोन",
  enterNumber: "नंबर दर्ज करें",
  enterEmail: "ईमेल दर्ज करें",
  address: "पता",
  address1: "पता 1",
  address2: "पता 2",
  social: "सोशल",
  workingHours: "कार्य समय",
  openTime: "खुलने का समय",
  closeTime: "बंद होने का समय",
  uploadProfileImage: "प्रोफाइल छवि अपलोड करें",
  uploadYourBannerImage: "अपना बैनर इमेज अपलोड करें",
  upload: "अपलोड करें",
  sizeShouldBeLessThan: "आकार 5mb से कम होना चाहिए",
  uploadLogo: "लोगो अपलोड करें",
  uploadYourLogo: "अपना लोगो अपलोड करें",
  selectImage: "छवि चुनें",
  uploadBannerImage: "बैनर छवि अपलोड करें",
  fileResolutionIsGreaterThen: "फ़ाइल का रिज़ॉल्यूशन 1900*1280 से अधिक है",
  imageVideo: "छवि/वीडियो",
  aboutMedia: "मीडिया के बारे में",
  selectMedia: "मीडिया चुनें",
  about: "के बारे में",
  heading: "शीर्षक",
  aboutDescription: "विवरण के बारे में",
  reset: "रीसेट",
  portfolio: "पोर्टफोलियो",
  enterTitle: "शीर्षक दर्ज करें",
  description: "विवरण",
  title: "शीर्षक",
  externalLink: "बाहरी लिंक",
  image: "छवि",
  addMore: "और जोड़ें",
  addProfessionalSkills: "व्यावसायिक कौशल जोड़ें",
  skill: "कौशल",
  percentage: "प्रतिशत",
  addServices: "सेवाएँ जोड़ें",
  serviceDescription: "सेवा विवरण",
  addEducation: "शिक्षा जोड़ें",
  universityInstituteName: "विश्वविद्यालय/संस्थान का नाम",
  degree: "डिग्री",
  course: "पाठ्यक्रम",
  addWorkExperience: "कार्य अनुभव जोड़ें",
  jobProfile: "नौकरी प्रोफाइल",
  workingyear: "कार्य वर्ष",
  addProducts: "उत्पाद जोड़ें",
  price: "मूल्य",
  addPricingPlans: "मूल्य निर्धारण योजनाएँ जोड़ें",
  subHeading: "उप-शीर्षक",
  buttonText: "बटन टेक्स्ट",
  features: "विशेषताएं",
  addIncrement: "वृद्धि जोड़ें",
  counterNumber: "काउंटर नंबर",
  addTestimonials: "प्रशंसापत्र जोड़ें",
  teamMembers: "टीम के सदस्य",
  designation: "पद",
  addBlog: "ब्लॉग जोड़ें",
  externalLink: "बाहरी लिंक",
  addAchievement: "उपलब्धि जोड़ें",
  addReference: "संदर्भ जोड़ें",
  comment: "टिप्पणी",
  sorryAnUnexpectedErrorHasOccurred: "क्षमा करें, एक अप्रत्याशित त्रुटि हुई है",
  tryAgain: "पुनः प्रयास करें",
  savePreview: "सहेजें और पूर्वावलोकन करें",
  save: "सहेजें",
  yourProgressHasBeenSaved: "आपकी प्रगति सहेजी गई है",
  addVideos: "वीडियो जोड़ें",
  video: "वीडियो",

  update: "अपडेट",
  domainSetup: "डोमेन सेटअप",
  choosingTheRightDomainNameIsTheFirstStep: "सही डोमेन नाम चुनना एक मजबूत ऑनलाइन उपस्थिति स्थापित करने की दिशा में पहला कदम है। MyDigitalIndia में, हम आपके लिए ऐसा आदर्श डोमेन ढूंढना और पंजीकरण करना आसान बनाते हैं जो आपके ब्रांड को प्रतिबिंबित करता है और आपके ग्राहकों के लिए याद रखने में आसान है।",
  instructionVideo: "निर्देश वीडियो",
  checkoutPage: "चेकआउट पेज",
  thankYouForChoosingMyDigitalIndia: "MyDigitalIndia चुनने के लिए धन्यवाद! कृपया नीचे अपने ऑर्डर का विवरण देखें। चेकआउट पर आगे बढ़ने से पहले सुनिश्चित करें कि सारी जानकारी सही है।",
  yourOrderHasBeenConfirmed: "आपका ऑर्डर पुष्टि हो गया है",
  thankYouForChoosing: "MyDigitalIndia चुनने के लिए धन्यवाद",
  weAreThrilledToHaveYouOnBoard: "हम आपको अपने साथ देखकर उत्साहित हैं और आपकी एक शानदार ऑनलाइन उपस्थिति बनाने में मदद करने के लिए तत्पर हैं।",
  orderSummary: "ऑर्डर सारांश",
  summary: "सारांश",
  planDetails: "योजना विवरण",
  noteItWillTakeDaysForYourWebsiteToGetPublished: "नोट: आपकी वेबसाइट को पहली बार प्रकाशित होने में 5-10 दिन लगेंगे। आपकी सहनशीलता के लिए धन्यवाद।",
  welcomelogin: "स्वागत!",
  greatToseeu: "तुमसे मिलकर बहुत अच्छा लगा! अपनी वेबसाइट को चलते-फिरते आसानी से प्रबंधित करें—त्वरित और सरल।",
  enterUrmail: "अपना ईमेल दर्ज करें :",
  passworD: "पासवर्ड :",
  forgotPass: "क्या आपने पासवर्ड भूल लिया?",
  clikhere: "यहाँ क्लिक करें",
  loginmobi: "मोबाइल से साइन अप करें",
  logingoog: "गूगल से साइन अप करें",
  loginaple: "एप्पल से साइन अप करें",
  loginmail: "ईमेल से साइन अप करें",
  donthavAccount: "क्या आपके पास खाता नहीं है?",
  dontwrry: "चिंता मत करें। हम आपकी मदद के लिए तैयार हैं।",
  reseopt: "OTP फिर से भेजें",
  backttop: "लॉगिन पृष्ठ पर वापस जाएं",
  createanacc: "खाता बनाएं",
  getaccessto: "हमारे विस्तृत टेम्पलेट्स तक पहुँच प्राप्त करें और आज ही अपनी डिजिटल यात्रा शुरू करें!",
  alreadyacc: "क्या आपके पास पहले से खाता है?",
  availtodownload: "डाउनलोड करने के लिए उपलब्ध:",
  contacus: "हमसे संपर्क करें",
  contacdescp: "माईडिजिटलइंडिया में, आपकी सफलता हमारी प्राथमिकता है। चाहे आपका कोई प्रश्न हो, सहायता की आवश्यकता हो या आप प्रतिक्रिया देना चाहते हों, हम हर कदम पर आपका समर्थन करने के लिए यहां मौजूद हैं। हमारी समर्पित टीम किसी भी पूछताछ में आपकी सहायता करने और यह सुनिश्चित करने के लिए तैयार है कि आपको सर्वोत्तम अनुभव मिले।",
  get24suppo: "24/7 समर्थन प्राप्त करें",
  youcanaskcontac: "आप किसी भी सवाल के लिए सवाल पूछ सकते हैं, ट्यूटोरियल देख सकते हैं या किसी भी प्रश्न पर लेख ब्राउज़ कर सकते हैं, किसी भी समय और कहीं भी।",
  prefermailreac1: "क्या आप हमें ईमेल भेजना पसंद करेंगे? हमें इस पर संपर्क करें",
  prefermailreac2: "और हम 24 घंटों के भीतर आपसे संपर्क करेंगे।",
  livchat: "लाइव चैट",
  connecwithus1: "हमारे लाइव चैट फीचर के माध्यम से तुरंत हमसे संपर्क करें। हमारे ग्राहक सहायता प्रतिनिधि",
  connecwithus2: "से उपलब्ध हैं, जो तात्कालिक सहायता प्रदान करेंगे।",
  contacform: "संपर्क फ़ॉर्म",
  fillouteasy: "नीचे हमारे उपयोगकर्ता-अनुकूल संपर्क फ़ॉर्म को भरें, और हम शीघ्र ही उत्तर देंगे। कृपया हमें जितना संभव हो सके विवरण प्रदान करें ताकि हम आपकी inquiry को प्रभावी ढंग से संबोधित कर सकें।",
  submit: "जमा करें",
  fistnam: "पहला नाम",
  lasnam: "अंतिम नाम",
  mobinumber: "मोबाइल नंबर",
  messaGe: "संदेश",
  folowUs: "हमारा पालन करें",
  joinurvibrantcomm: "हमारे जीवंत समुदाय में शामिल हों और डिजिटल दुनिया में नवीनतम समाचार, अपडेट और रुझानों के साथ अपडेट रहें। सोशल मीडिया पर हमें फॉलो करके, आप नई सुविधाओं, रोमांचक ऑफ़र, विशेषज्ञ टिप्स और बहुत कुछ के बारे में पहले जानेंगे।",
  editThisTemplate: "इस टेम्पलेट को संपादित करें",
  welcomeMessageppolicy: "मेरे डिजिटल इंडिया ऐप में आपका स्वागत है। हमारे प्लेटफ़ॉर्म और सेवाओं (\"सेवाएं\") का उपयोग करके, आप निम्नलिखित सेवा की शर्तों (\"शर्तें\") से सहमत होते हैं। कृपया इन शर्तों को ध्यानपूर्वक पढ़ें, क्योंकि ये आपके My Digital India App प्लेटफ़ॉर्म और उसकी संबंधित सेवाओं के उपयोग को नियंत्रित करती हैं।",

  acceptanceOfTermsppolicy: "My Digital India App की सेवाओं का उपयोग करके, आप इन शर्तों, हमारी गोपनीयता नीति और उन किसी भी अतिरिक्त नीतियों या दिशानिर्देशों का पालन करने के लिए सहमत होते हैं जो हमारी सेवाओं पर लागू होती हैं। यदि आप इन शर्तों से सहमत नहीं हैं, तो आपको हमारा प्लेटफ़ॉर्म उपयोग नहीं करना चाहिए।",

  changesToTermsppolicy: "हम अपनी सेवाओं या कानूनी दायित्वों में बदलाव को दर्शाने के लिए इन शर्तों को किसी भी समय संशोधित या अपडेट करने का अधिकार सुरक्षित रखते हैं। यदि हम इन शर्तों में कोई महत्वपूर्ण परिवर्तन करते हैं, तो हम ईमेल या प्लेटफ़ॉर्म के माध्यम से सूचना देंगे। सेवाओं का निरंतर उपयोग संशोधित शर्तों की आपकी स्वीकृति को दर्शाता है। हम आपको किसी भी बदलाव के लिए इस पृष्ठ पर अद्यतन रहने के लिए प्रोत्साहित करते हैं।",

  servicesProvidedppolicy: "My Digital India App पूर्व-डिज़ाइन टेम्पलेट्स के साथ स्वयं वेबसाइट विकास सेवाएं प्रदान करता है। हम अपनी इच्छा से सेवाओं को जोड़, संशोधित या हटा सकते हैं। आप स्वीकार करते हैं कि हम समय-समय पर अपनी सेवाओं की विशेषताओं, कार्यक्षमता या उपलब्धता को अपडेट या बदल सकते हैं।",

  userAccountsppolicy: "My Digital India App की कुछ विशेषताओं का उपयोग करने के लिए, आपको एक खाता बनाना होगा। आप पंजीकरण के दौरान सटीक, अद्यतन और पूर्ण जानकारी प्रदान करने और इस जानकारी की सटीकता बनाए रखने के लिए सहमत होते हैं। आप अपने खाते के लॉगिन विवरणों की सुरक्षा और खाते के तहत सभी गतिविधियों के लिए जिम्मेदार हैं।",

  usageOfServicesppolicy: "आप सेवाओं का उपयोग केवल वैध उद्देश्यों के लिए और हमारी दिशानिर्देशों के अनुसार करने के लिए सहमत होते हैं। निषिद्ध गतिविधियों में शामिल हैं:",
  prohibitedActivitiesppolicy: [
    "धोखाधड़ी, भ्रामक या अवैध गतिविधियों में संलग्न होना।",
    "My Digital India App या तीसरे पक्ष के बौद्धिक संपदा अधिकारों का उल्लंघन करना।",
    "सेवाओं को बाधित करने या हस्तक्षेप करने का प्रयास करना।"
  ],

  contentOwnershipppolicy: "My Digital India App के माध्यम से प्रदान की गई सभी सामग्री, जिसमें पाठ, छवियां, ग्राफिक्स, लोगो और सॉफ़्टवेयर शामिल हैं, बौद्धिक संपदा कानूनों द्वारा संरक्षित हैं। आप जो भी सामग्री अपलोड करते हैं, उसके स्वामी आप बने रहते हैं, लेकिन अपलोड करने पर, आप My Digital India App को एक विश्वव्यापी, गैर-विशिष्ट, रॉयल्टी-मुक्त लाइसेंस प्रदान करते हैं ताकि सेवाओं के संचालन के लिए आवश्यकतानुसार आपकी सामग्री का उपयोग, प्रदर्शन और वितरण किया जा सके।",
  intellectualPropertyppolicy: "आप स्वीकार करते हैं कि My Digital India App प्लेटफ़ॉर्म से संबंधित सभी ट्रेडमार्क, सेवा चिह्न, लोगो और स्वामित्व अधिकारों का स्वामित्व रखता है। आप बिना पूर्व लिखित अनुमति के My Digital India App की बौद्धिक संपदा का उपयोग नहीं करेंगे।",

  thirdPartyServicesppolicy: "My Digital India App तीसरे पक्ष की सेवाओं, उत्पादों या अनुप्रयोगों (सामूहिक रूप से “थर्ड-पार्टी सेवाएं”) को एकीकृत कर सकता है। हम इन सेवाओं का समर्थन या नियंत्रण नहीं करते हैं और उनके कार्य, उपलब्धता या उपयोग से उत्पन्न किसी भी समस्या के लिए जिम्मेदार नहीं हैं।",
  thirdPartyAgreementppolicy: "तीसरे पक्ष की सेवाओं का उपयोग करके, आप उनकी संबंधित शर्तों और गोपनीयता नीतियों का पालन करने के लिए सहमत होते हैं। हम इन सेवाओं के उपयोग से उत्पन्न किसी भी नुकसान या हानि के लिए उत्तरदायी नहीं हैं।",

  privacyPolicyppolicy: "सेवाओं का आपका उपयोग हमारी गोपनीयता नीति द्वारा शासित होता है, जो यह वर्णन करती है कि हम आपके व्यक्तिगत डेटा को कैसे एकत्र, उपयोग और सुरक्षित रखते हैं। प्लेटफ़ॉर्म का उपयोग करके, आप गोपनीयता नीति में उल्लिखित हमारे डेटा प्रथाओं के लिए सहमति देते हैं।",

  feesAndPaymentsppolicy: "यदि आप My Digital India App पर भुगतान की जाने वाली सेवाओं का उपयोग करते हैं, तो आप उन सेवाओं के लिए लागू शुल्क का भुगतान करने के लिए सहमत होते हैं। भुगतान शर्तें, बिलिंग चक्र, और वापसी नीति खरीद प्रक्रिया के दौरान निर्दिष्ट की जाती हैं। हम किसी भी समय अपने शुल्कों में बदलाव करने का अधिकार सुरक्षित रखते हैं, लेकिन हम शुल्क में किसी भी परिवर्तन के प्रभाव में आने से पहले आपको सूचित करेंगे।",

  terminationAndSuspensionppolicy: "यदि हमें विश्वास है कि आपने इन शर्तों का उल्लंघन किया है या My Digital India App या उसके उपयोगकर्ताओं के लिए हानिकारक गतिविधियों में संलग्न हैं, तो हम अपने विवेक पर, बिना पूर्व सूचना के, आपकी सेवाओं तक पहुंच को निलंबित या समाप्त कर सकते हैं। आप भी किसी भी समय अपना खाता समाप्त कर सकते हैं।",
  postTerminationppolicy: "समाप्ति के बाद, आपकी सेवाओं तक पहुंच समाप्त हो जाएगी और आपके खाते से संबंधित किसी भी सामग्री, डेटा या विशेषताओं तक आपकी पहुंच नहीं होगी।",

  disclaimersppolicy: "सेवाएं “जैसी की तैसी” प्रदान की जाती हैं, जिनमें कोई व्यक्त या निहित वारंटी नहीं होती। My Digital India App यह गारंटी नहीं देता कि प्लेटफ़ॉर्म त्रुटि-मुक्त, निर्बाध या सुरक्षित होगा। आप प्लेटफ़ॉर्म का उपयोग अपने जोखिम पर करते हैं, और हम आपकी सेवाओं के उपयोग से उत्पन्न किसी भी नुकसान के लिए जिम्मेदार नहीं हैं।",

  limitationOfLiabilityppolicy: "कानून द्वारा अनुमत अधिकतम सीमा तक, My Digital India App की सेवाओं के उपयोग से उत्पन्न किसी भी दावे, हानि, या क्षति के लिए हमारी ज़िम्मेदारी उस राशि तक सीमित है जो आपने दावे से पहले 12 महीनों के दौरान सेवाओं के लिए भुगतान की है। हम किसी भी अप्रत्यक्ष, आकस्मिक या परिणामी क्षति के लिए जिम्मेदार नहीं हैं।",

  indemnificationppolicy: "आप My Digital India App, उसकी सहायक कंपनियों, कर्मचारियों, एजेंटों, और भागीदारों को सेवाओं के आपके उपयोग, इन शर्तों के उल्लंघन, या बौद्धिक संपदा अधिकारों के उल्लंघन से उत्पन्न किसी भी दावे, हानि या क्षति से क्षतिपूर्ति और संरक्षित रखने के लिए सहमत होते हैं।",

  governingLawppolicy: "इन शर्तों को भारत के कानूनों द्वारा नियंत्रित किया जाएगा, इसके कानूनों के संघर्ष सिद्धांतों की परवाह किए बिना। इन शर्तों से उत्पन्न किसी भी विवाद को [इंदौर (म.प्र.), भारत] स्थित न्यायालयों में सुलझाया जाएगा।",

  forceMajeureppolicy: "My Digital India App किसी भी ऐसी विफलता या देरी के लिए जिम्मेदार नहीं होगा जो उसकी उचित नियंत्रण से बाहर की परिस्थितियों के कारण हो, जिनमें प्राकृतिक आपदाएं, सरकारी कार्य, या तकनीकी विफलताएं शामिल हैं।",

  severabilityppolicy: "यदि इन शर्तों का कोई प्रावधान अमान्य या अप्रवर्तनीय पाया जाता है, तो शेष प्रावधान पूरी तरह से प्रभावी रहेंगे।",

  entireAgreementppolicy: "ये शर्तें, गोपनीयता नीति और किसी भी अन्य सम्मिलित शर्तों के साथ, सेवाओं के उपयोग के संबंध में आपके और My Digital India App के बीच पूर्ण समझौता बनाती हैं।",

  contactInformationppolicy: "यदि आपको इन सेवा की शर्तों के बारे में कोई प्रश्न है या सहायता की आवश्यकता है, तो कृपया हमसे संपर्क करें:\nMy Digital India App सहायता\n[ईमेल पता]\n[फोन नंबर]",

  thankYouppolicy: "My Digital India App का उपयोग करके, आप इन सेवा की शर्तों से सहमत होते हैं। हमारे समुदाय का हिस्सा बनने के लिए धन्यवाद।"


}
export default hindiLang;